import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/guillemet-start.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/guillemets-end.svg';
export default {
  name: 'GlobalQuote',
  props: {
    iconColor: {
      type: String,
      required: true
    },
    textColor: {
      type: String,
      required: true
    },
    paragraph: {
      type: Array,
      required: true
    },
    signature: {
      type: String,
      required: true
    }
  }
};